<template>
  <div :class="$style[classes]">
     <pt-page-title title="发票管理" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
    </pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter">
      <el-button type="primary" @click="filter()">筛选</el-button>
      <template>
        <el-button type="primary" @click="exportInvoice()" :loading="exportLoading">导出</el-button>
        <!-- <el-button type="primary" @click="exportOldToNewAudit(true)" v-if="hasAllExport" :loading="exportLoading">导出全部记录</el-button> -->
        <el-button type="primary" @click.native="exportHistoryInvoice">导出历史</el-button>
      </template>
      <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
    </pt-page-factor-filter>
    <pt-life-experience-pavilion-reservation-table ref="table" :params="paramsQuery" :isInvoice="true" :isFromRouter="true"
    :class="$style['pt-invoice-table']" >
    </pt-life-experience-pavilion-reservation-table>
  </div>
</template>

<script>
// 组件class前缀
import { filterLabels } from './invoice'
import ptLifeExperiencePavilionReservationTable from '../pt-life-experience-pavilion-reservation//pt-life-experience-pavilion-reservation-table/withData.vue'
const prefixCls = 'pt-life-experience-pavilion-invoice'
export default {
  name: 'pt-life-experience-pavilion-invoice',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptLifeExperiencePavilionReservationTable
  },
  props: {
    exportLoading: Boolean
  },
  data () {
    return {
      filterLabels,
      params: {
      },
      searchKey: null,
      paramsQuery: {}
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      this.paramsQuery = { searchKey: val }
    },
    emptySearch () {
      this.paramsQuery.searchKey = null
    },
    filter () {
      this.searchKey = null
      this.paramsQuery = { ...this.params }
    },

    exportInvoice () {
      if (this.$refs.table.tableData && this.$refs.table.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          let params = { ...this.params }
          for (var key2 in params) {
            if (!params[key2]) {
              this.$delete(params, key2)
            }
          }
          this.$emit('reservationExport', params)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryInvoice () {
      this.$router.push('/export-history/reservation-invoice-export?name=reservation_invoice_export')
    },
    cleanParams () {
      this.paramsQuery = {}
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-life-experience-pavilion-invoice{}
.pt-invoice-table{
}
</style>
